import { Box, Chip, Typography } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import { formatFechaCorta } from "../../../common/utils/formatDate";

export const buildColumnsPedidosRRHH = () => [
  {
    accessorKey: "fecha",
    header: "Fecha",
    maxSize: 90,
    Cell: ({ cell }) => formatFechaCorta(cell.getValue()),
  },
  {
    accessorKey: "nombre_empleado",
    header: "Empleado",
    Cell: ({ cell, row }) => (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <PersonIcon sx={{ fontSize: 17, color: "#1F618D" }} />
        <Box>
          <Typography sx={{ fontWeight: 600, fontSize: "0.83rem" }}>
            {cell.getValue() || row.original.id_usuario}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            {row.original.legajo ? `Legajo ${row.original.legajo}` : row.original.id_usuario}
          </Typography>
        </Box>
      </Box>
    ),
  },
  { accessorKey: "menu", header: "Menú" },
  { accessorKey: "proveedor", header: "Proveedor" },
  {
    accessorKey: "sucursal",
    header: "Sucursal",
    Cell: ({ cell }) => <Chip label={cell.getValue()} size="small" variant="outlined" />,
  },
];
